import { array, nullable, string, struct } from 'io-ts/Decoder';

import { Id as FormulaUsageId } from '../../formula/usage/Id';
import { Id as MaterialTemplateUsageId } from '../../material-template/usage/Id';
import { Id as UsageId } from '../../usage/Id';

export const TypeV2 = struct({
	ingredientName: nullable(string),
	note: nullable(string),
	usageId: UsageId,
	formulaUsageId: FormulaUsageId,
	materialTemplateUsageIds: array(MaterialTemplateUsageId),
});
